import { TxpOptionState } from '../store/schema/TxpOptionState';
import { getFallbackValueIfNull } from 'owa-options-core';
import getStore from '../store/store';
import { TxpGriffinSettingsPayload } from 'owa-calendar-configuration';
import getTxpSettings from 'owa-calendar-configuration/lib/utils/getTxpSettings';

export interface IsTxpOptionDirtyState {
    optionState: TxpOptionState;
}

/**
 * Returns if the Txp options page is in dirty state (user made changes to it)
 */
export default function isTxpOptionDirtyV2(state?: IsTxpOptionDirtyState): boolean {
    let savedOptions: TxpGriffinSettingsPayload = getTxpSettings();
    let optionState = getStore();

    if (!savedOptions) {
        return false;
    }

    let CreateEventsFromEmailAsPrivate = getFallbackValueIfNull(
        optionState.CreateEventsFromEmailAsPrivate,
        savedOptions.CreateEventsFromEmailAsPrivate
    );

    if (CreateEventsFromEmailAsPrivate !== savedOptions.CreateEventsFromEmailAsPrivate) {
        return true;
    }

    let isEventFlagDirty = false;

    // Validate if the event flags are changed
    Object.keys(optionState.EntityTypeProcessorLevelSettings).map(eventType => {
        let eventEnabled = getFallbackValueIfNull(
            optionState.EntityTypeProcessorLevelSettings[eventType],
            savedOptions.EntityTypeProcessorLevelSettings[eventType]
        );

        if (eventEnabled !== savedOptions.EntityTypeProcessorLevelSettings[eventType]) {
            isEventFlagDirty = true;
        }
    });

    return isEventFlagDirty;
}
